import React from 'react';

function Footer() {
    return <footer className="pegasus-ui pegasus-footer">
        <span>© Le Céladon <span className="sc-mx-2 sc-text-border">/</span> Pegasus workspace</span>
        <nav className="pegasus-footer-links" aria-label="Liens de pied de page">
            <a href="https://le-celadon.ma/" target="_blank" rel="noopener noreferrer">Le Céladon</a>
            <a href="https://accounting.office.le-celadon.ma/" target="_blank" rel="noopener noreferrer">Accounting</a>
            {['Support', 'Help Center', 'Privacy', 'Terms'].map(label =>
                <a key={label} href="https://adminkit.io/" target="_blank" rel="noopener noreferrer">{label}</a>)}
        </nav>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.3/js/bootstrap.min.js" integrity="sha512-ykZ1QQr0Jy/4ZkvKuqWn4iF3lqPZyij9iRv6sGqLRdTPkY69YX6+7wvVGmsdBbiIfN/8OdsI7HABjvEok6ZopQ==" crossOrigin="anonymous" referrerPolicy="no-referrer"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/2.9.2/umd/popper.min.js" integrity="sha512-2rNj2KJ+D8s1ceNasTIex6z4HWyOnEYLVC3FigGOmyQCZc2eBXKgOxQmo3oKLHyfcj53uz4QMsRCWNbLd32Q1g==" crossOrigin="anonymous" referrerPolicy="no-referrer"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/feather-icons/4.29.2/feather.min.js" integrity="sha512-zMm7+ZQ8AZr1r3W8Z8lDATkH05QG5Gm2xc6MlsCdBz9l6oE8Y7IXByMgSm/rdRQrhuHt99HAYfMljBOEZ68q5A==" crossOrigin="anonymous" referrerPolicy="no-referrer"></script>

    </footer>;
}

export default Footer;
